import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { MapFastighetComponent , mapFastighetWidgetId } from "@components/map/components/menu/map-fastighet/map-fastighet.component";
import { MapLayersComponent } from "@components/map/components/menu/map-layers/map-layers.component";
import { MapComponent } from "@components/map/map.component";
import { isNil } from "lodash";
import { FastighetGeometry } from "~app/common/components/map/components/menu/map-fastighet/map-fastighet-models";

import { IMapComponent } from "~app/common/components/map/map.models";
import { IMapSettings } from "~app/common/components/map/map.settings";

@Component({
    selector: "rask-vk-karta-fastigheter",
    templateUrl: "./vk-karta-fastigheter.component.html",
    styleUrls: ["./vk-karta-fastigheter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MapComponent,
        MapFastighetComponent,
        MapLayersComponent
    ]
})
export class VkKartaFastigheterComponent implements OnInit {
    @Output() imported = new EventEmitter<FastighetGeometry>();
    mapsettings: IMapSettings;
    map: IMapComponent;

    ngOnInit(): void {
        this.mapsettings = {
            id: "virkeskop-fastigheter",
            height: "700px",
            center: [
                16.1932,
                62.2315
            ],
            zoom: 0,
            baselayers: [
                { id: "metriabakgrund",
                    visible: true },
                { id: "metriaorto",
                    visible: true }
            ],
            featurelayers: [
                { id: "MetriaFastighetsgranser",
                    visible: true }
            ],
            scaleBar: true,
            measure: false,
            coords: true,
            drawLayers: [],
            defaultWidgetId: mapFastighetWidgetId,
            onMapReady: (map) => this.onMapReady(map)
        } as IMapSettings;
    }

    onMapReady(map: IMapComponent): void {
        this.map = map;
    }

    onImportingFastighet($event: FastighetGeometry): void {
        if (isNil($event)) {
            return;
        }
        this.imported.emit($event);
        this.map.closePopups();
        this.map.closeWidgets();
    }
}
